import clsx from 'clsx';
import { ReactNode } from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './AvatarSpeechBubble.module.css';

interface AvatarSpeechBubbleProps {
  children: ReactNode;
  backgroundColour?: 'coral' | 'purple';
  tailPosition?: 'left-side' | 'left-corner';
  onCloseClicked?: () => void;
}

const AvatarSpeechBubble = ({
  children,
  backgroundColour = undefined,
  tailPosition = 'left-side',
  onCloseClicked,
}: AvatarSpeechBubbleProps) => {
  return (
    <div
      className={clsx(
        styles.container,
        styles['background__' + backgroundColour],
      )}
    >
      <div className={styles.bubble}>{children}</div>
      <div className={clsx(styles.tail, styles[`tail__${tailPosition}`])} />
      {onCloseClicked && (
        <button
          className={styles.closeButton}
          aria-label="close"
          onClick={onCloseClicked}
        >
          <img
            src={`${ASSET_PREFIX}/images/close_button.svg`}
            alt=""
            width="12"
            height="12"
          />
        </button>
      )}
    </div>
  );
};

export default AvatarSpeechBubble;
